import { RootState } from '@reducers';

export const selectCarQuoteBuy = (state: RootState) => state.carQuoteBuyRouteReducer;
